export const BRAND_NAME = 'Delight Business Empowerment';
export const DEFAULT_SITE_URL = 'https://delightempowerment.com';
export const DEFAULT_OG_IMAGE =
  'https://images.unsplash.com/photo-1556761175-b413da4baf72?auto=format&fit=crop&w=1200&h=630&q=80';
export const DEFAULT_OG_IMAGE_ALT =
  'Delight Business Empowerment women empowerment community and business mentorship';

const trimTrailingSlash = (value: string) => value.replace(/\/+$/, '');

export const getSiteUrl = () => {
  const configuredUrl = import.meta.env.VITE_SITE_URL?.trim();

  if (configuredUrl) {
    return trimTrailingSlash(configuredUrl);
  }

  if (typeof window !== 'undefined' && window.location.origin) {
    return trimTrailingSlash(window.location.origin);
  }

  return DEFAULT_SITE_URL;
};

export const toAbsoluteUrl = (path = '/') => {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const normalizedPath = path === '/' ? '/' : `/${path.replace(/^\/+/, '')}`;
  const absoluteUrl = new URL(normalizedPath, `${getSiteUrl()}/`).toString();

  return normalizedPath === '/' ? absoluteUrl : absoluteUrl.replace(/\/$/, '');
};
